import { createRequest, throwResErrors, createHeaders } from "./requestUtil";

export const getCsvOnboardedBrokers = (carrierId, listType) => {
	return createRequest()
		.get(`api/profile/carriers/${carrierId}/brokers/${listType}/download`, { headers: createHeaders() })
		.then((res) => res.data)
		.catch((error) => throwResErrors(error));
};

export const uploadCsvBrokersLists = (carrierId, listType, data) => {
	return createRequest()
		.post(`api/profile/carriers/${carrierId}/brokers/${listType}/upload`, data, { headers: createHeaders() })
		.then((res) => res.data)
		.catch((error) => throwResErrors(error));
};

export const getCarrierTrucks = (carrierId) => {
	let url = `api/profile/carriers/${carrierId}/trucks`;
	return createRequest()
		.get(url, { headers: createHeaders() })
		.then((res) => res.data)
		.catch((error) => throwResErrors(error));
};

export const getCarrierConfig = (carrierId) => {
	const url = `api/profile/carriers/${carrierId}/details/configuration`;
	return createRequest()
		.get(url, { headers: createHeaders() })
		.then((res) => res.data)
		.catch((error) => throwResErrors(error));
};

export const getCarriers = ({ params }) => {
	const url = `api/profile/carriers`;
	return createRequest()
		.get(url, { headers: createHeaders(), params })
		.then((res) => res.data)
		.catch((error) => throwResErrors(error));
};

export const getCarrierFile = (carrierId, fileId) => {
	const url = `/api/profile/carriers/${carrierId}/files/${fileId}`;
	return createRequest()
		.get(url, { headers: createHeaders(), responseType: "blob" })
		.then((res) => res.data)
		.catch((error) => throwResErrors(error));
};

export const getCarrierInformation = (carrierId) => {
	const url = `api/profile/carriers/${carrierId}/details/company-information`;
	return createRequest()
		.get(url, { headers: createHeaders() })
		.then((res) => res.data)
		.catch((error) => throwResErrors(error));
};

export const updateCarrierInformation = (carrierId, data) => {
	const url = `api/profile/carriers/${carrierId}/details/company-information`;
	return createRequest()
		.put(url, { data }, { headers: createHeaders() })
		.then((res) => res.data)
		.catch((error) => throwResErrors(error));
};

export const getCarrierDOTInformation = (carrierId, mc, dot) => {
	const url = `api/profile/carriers/${carrierId}/details/company-information/dot/sync?mc=${mc}&dot=${dot}`;
	return createRequest()
		.get(url, { headers: createHeaders() })
		.then((res) => res.data)
		.catch((error) => throwResErrors(error));
};

export const sendCarrierDOTPhoneCode = (carrierId, data) => {
	const url = `api/profile/carriers/${carrierId}/details/company-information/dot/phone/send-code`;
	return createRequest()
		.post(url, { data }, { headers: createHeaders() })
		.then((res) => res.data)
		.catch((error) => throwResErrors(error));
};

export const sendCarrierDOTEmailCode = (carrierId, data) => {
	const url = `api/profile/carriers/${carrierId}/details/company-information/dot/email/send-code`;
	return createRequest()
		.post(url, { data }, { headers: createHeaders() })
		.then((res) => res.data)
		.catch((error) => throwResErrors(error));
};

export const verifyCarrierDOTValidationCode = (carrierId, data) => {
	const url = `api/profile/carriers/${carrierId}/details/company-information/dot/validation/verify-code`;
	return createRequest()
		.post(url, { data }, { headers: createHeaders() })
		.then((res) => res.data)
		.catch((error) => throwResErrors(error));
};

export const getDotInformation = (carrierId) => {
	const url = `api/profile/carriers/${carrierId}/dot-information`;
	return createRequest()
		.get(url, { headers: createHeaders() })
		.then((res) => res.data)
		.catch((error) => throwResErrors(error));
};

export const getCarrierPayrollSettings = (carrierId) => {
	const url = `api/profile/carriers/${carrierId}/details/payroll-settings`;
	return createRequest()
		.get(url, { headers: createHeaders() })
		.then((res) => res.data)
		.catch((error) => throwResErrors(error));
};

export const getCarrierFuelSettings = (carrierId) => {
	const url = `api/profile/carriers/${carrierId}/details/fuel`;
	return createRequest()
		.get(url, { headers: createHeaders() })
		.then((res) => res.data)
		.catch((error) => throwResErrors(error));
};

export const getCarrierInvoiceSettings = (carrierId) => {
	const url = `api/profile/carriers/${carrierId}/invoicing-settings`;
	return createRequest()
		.get(url, { headers: createHeaders() })
		.then((res) => res.data)
		.catch((error) => throwResErrors(error));
};

export const getCarrierCustomer = (carrierId) => {
	const url = `billing/carriers/${carrierId}/customer`;
	return createRequest()
		.get(url, { headers: createHeaders() })
		.then((res) => res.data)
		.catch((error) => throwResErrors(error));
};

export const requestSendTestEmail = (carrierId) => {
	const url = `api/profile/carriers/${carrierId}/branding-mail-conf-test`;
	return createRequest()
		.post(url, { headers: createHeaders() })
		.then((res) => res.data)
		.catch((error) => throwResErrors(error));
};

export const updateCarrierBrandingMailConf = (carrierId, data) => {
	const url = `api/profile/carriers/${carrierId}/branding-mail-conf`;
	return createRequest()
		.put(url, { data }, { headers: createHeaders() })
		.then((res) => res.data)
		.catch((error) => throwResErrors(error));
};

export const getCarrierBrandingMailConf = (carrierId) => {
	return createRequest()
		.get(`/api/profile/carriers/${carrierId}/branding-mail-conf`, { headers: createHeaders() })
		.then((res) => res.data)
		.catch((error) => throwResErrors(error));
};

export const getCarrierBranding = (carrierId) => {
	const url = `api/profile/carriers/${carrierId}/branding`;
	return createRequest()
		.get(url, { headers: createHeaders() })
		.then((res) => res.data)
		.catch((error) => throwResErrors(error));
};

export const getCarrierFuelModule = (carrierId) => {
	const url = `api/profile/carriers/${carrierId}/details/fuel`;
	return createRequest()
		.get(url, { headers: createHeaders() })
		.then((res) => res.data)
		.catch((error) => throwResErrors(error));
};

export const updateCarrierFuelModule = (carrierId, data) => {
	const url = `api/profile/carriers/${carrierId}/details/fuel`;
	return createRequest()
		.put(url, { data }, { headers: createHeaders() })
		.then((res) => res.data)
		.catch((error) => throwResErrors(error));
};

export const getNameOwnership = (carrierId) => {
	const url = `api/profile/carriers/${carrierId}/owner`;
	return createRequest()
		.get(url, { headers: createHeaders() })
		.then((res) => res.data)
		.catch((error) => throwResErrors(error));
};

export const changeOwnership = (carrierId, data) => {
	const url = `api/profile/carriers/${carrierId}/owner`;
	return createRequest()
		.post(url, { data }, { headers: createHeaders() })
		.then((res) => res.data)
		.catch((error) => throwResErrors(error));
};

export const getCarrierInvoiceIdConfig = (carrierId) => {
	return createRequest()
		.get(`/api/profile/carriers/${carrierId}/invoicing-settings`, { headers: createHeaders() })
		.then((res) => res.data)
		.catch((error) => throwResErrors(error));
};

export const getInvoicingPaymentInformation = (carrierId) => {
	return createRequest()
		.get(`/api/profile/carriers/${carrierId}/factoring-settings`, { headers: createHeaders() })
		.then((res) => res.data)
		.catch((error) => throwResErrors(error));
};

export const resetBrandingMailConfig = (carrierId) => {
	const url = `api/profile/carriers/${carrierId}/branding-mail-conf-reset`;
	return createRequest()
		.put(url, { headers: createHeaders() })
		.then((res) => res.data)
		.catch((error) => throwResErrors(error));
};

export const toggleEmailProvider = (carrierId, providerId) => {
	const url = `api/profile/carriers/${carrierId}/email-providers/${providerId}/toggle`;
	return createRequest()
		.put(url, {}, { headers: createHeaders() })
		.then((res) => res.data)
		.catch((error) => throwResErrors(error));
};

export const testEmailProvider = (carrierId, providerId) => {
	const url = `api/profile/carriers/${carrierId}/email-providers/${providerId}/test`;
	return createRequest()
		.post(url, {}, { headers: createHeaders() })
		.then((res) => res.data)
		.catch((error) => throwResErrors(error));
};

export const getCarrierOnboardingStatus = (carrierId) => {
	return createRequest()
		.get(`api/onboarding/carriers/${carrierId}/status`, { headers: createHeaders() })
		.then((res) => res.data)
		.catch((error) => throwResErrors(error));
};

export const resetInvoicingPaymentInformation = (carrierId) => {
	const url = `api/profile/carriers/${carrierId}/factoring-settings`;
	return createRequest()
		.delete(url, { headers: createHeaders() })
		.then((res) => res.data)
		.catch((error) => throwResErrors(error));
};

export const archiveCarrier = (carrierId) => {
	const url = `api/profile/carriers/${carrierId}/archive`;
	return createRequest()
		.delete(url, { headers: createHeaders() })
		.then((res) => res.data)
		.catch((error) => throwResErrors(error));
};

export const sendIntegrationBrokerRequest = (carrierId, brokerId, data) => {
	const url = `api/profile/carriers/${carrierId}/integrations/brokers/${brokerId}/request`;
	return createRequest()
		.post(url, { data }, { headers: createHeaders() })
		.then((res) => res.data)
		.catch((error) => throwResErrors(error));
};

export const connectAxle = (carrierId, data) => {
	const url = `api/profile/carriers/${carrierId}/axle/link`;
	return createRequest()
		.post(url, { data }, { headers: createHeaders() })
		.then((res) => res.data)
		.catch((error) => throwResErrors(error));
};

export const disconnectAxle = (carrierId) => {
	const url = `api/profile/carriers/${carrierId}/axle/link`;
	return createRequest()
		.delete(url, { headers: createHeaders() })
		.then((res) => res.data)
		.catch((error) => throwResErrors(error));
};

// Motive Integration Functions
export const connectMotive = (carrierId, data) => {
	const url = `api/profile/carriers/${carrierId}/motive/link`;
	return createRequest()
		.post(url, { data }, { headers: createHeaders() })
		.then((res) => res.data)
		.catch((error) => throwResErrors(error));
};

export const disconnectMotive = (carrierId) => {
	const url = `api/profile/carriers/${carrierId}/motive/link`;
	return createRequest()
		.delete(url, { headers: createHeaders() })
		.then((res) => res.data)
		.catch((error) => throwResErrors(error));
};

export const getMotiveVehicles = (carrierId) => {
	const url = `api/profile/carriers/${carrierId}/motive/vehicles`;
	return createRequest()
		.get(url, { headers: createHeaders() })
		.then((res) => res.data)
		.catch((error) => throwResErrors(error));
};

export const getMotiveDrivers = (carrierId) => {
	const url = `api/profile/carriers/${carrierId}/motive/drivers`;
	return createRequest()
		.get(url, { headers: createHeaders() })
		.then((res) => res.data)
		.catch((error) => throwResErrors(error));
};

export const getMotiveAssets = (carrierId) => {
	const url = `api/profile/carriers/${carrierId}/motive/assets`;
	return createRequest()
		.get(url, { headers: createHeaders() })
		.then((res) => res.data)
		.catch((error) => throwResErrors(error));
};

export const createMotiveDriver = (carrierId, data) => {
	const url = `api/profile/carriers/${carrierId}/motive/drivers`;
	return createRequest()
		.post(url, { data }, { headers: createHeaders() })
		.then((res) => res.data)
		.catch((error) => throwResErrors(error));
};

export const updateMotiveDriver = (carrierId, driverId, data) => {
	const url = `api/profile/carriers/${carrierId}/motive/drivers/${driverId}`;
	return createRequest()
		.put(url, { data }, { headers: createHeaders() })
		.then((res) => res.data)
		.catch((error) => throwResErrors(error));
};

export const createMotiveVehicle = (carrierId, data) => {
	const url = `api/profile/carriers/${carrierId}/motive/vehicles`;
	return createRequest()
		.post(url, { data }, { headers: createHeaders() })
		.then((res) => res.data)
		.catch((error) => throwResErrors(error));
};

export const updateMotiveVehicle = (carrierId, vehicleId, data) => {
	const url = `api/profile/carriers/${carrierId}/motive/vehicles/${vehicleId}`;
	return createRequest()
		.put(url, { data }, { headers: createHeaders() })
		.then((res) => res.data)
		.catch((error) => throwResErrors(error));
};

export const createMotiveAsset = (carrierId, data) => {
	const url = `api/profile/carriers/${carrierId}/motive/assets`;
	return createRequest()
		.post(url, { data }, { headers: createHeaders() })
		.then((res) => res.data)
		.catch((error) => throwResErrors(error));
};

export const updateMotiveAsset = (carrierId, assetId, data) => {
	const url = `api/profile/carriers/${carrierId}/motive/assets/${assetId}`;
	return createRequest()
		.put(url, { data }, { headers: createHeaders() })
		.then((res) => res.data)
		.catch((error) => throwResErrors(error));
};

// Motive API Key Management
export const updateMotiveKey = (carrierId, data) => {
	const url = `api/profile/carriers/${carrierId}/motive/key`;
	return createRequest()
		.put(url, data, { headers: createHeaders() })
		.then((res) => res.data)
		.catch((error) => throwResErrors(error));
};

export const deleteMotiveKey = (carrierId) => {
	const url = `api/profile/carriers/${carrierId}/motive/key`;
	return createRequest()
		.delete(url, { headers: createHeaders() })
		.then((res) => res.data)
		.catch((error) => throwResErrors(error));
};

export const getAxleImport = (carrierId) => {
	const url = `api/axle_import/carriers/${carrierId}`;
	return createRequest()
		.get(url, { headers: createHeaders() })
		.then((res) => res.data)
		.catch((error) => throwResErrors(error));
};

export const deleteTruckAxleImport = (carrierId, axleTruckId) => {
	const url = `api/axle_import/carriers/${carrierId}/axle_truck/${axleTruckId}`;
	return createRequest()
		.delete(url, { headers: createHeaders() })
		.then((res) => res.data)
		.catch((error) => throwResErrors(error));
};

export const updateTruckAxleImport = (carrierId, axleTruckId, data) => {
	const url = `api/axle_import/carriers/${carrierId}/axle_truck/${axleTruckId}`;
	return createRequest()
		.put(url, { data }, { headers: createHeaders() })
		.then((res) => res.data)
		.catch((error) => throwResErrors(error));
};

export const updateDriverAxleImport = (carrierId, axleDriverId, data) => {
	const url = `api/axle_import/carriers/${carrierId}/axle_driver/${axleDriverId}`;
	return createRequest()
		.put(url, { data }, { headers: createHeaders() })
		.then((res) => res.data)
		.catch((error) => throwResErrors(error));
};

export const deleteDriverAxleImport = (carrierId, axleDriverId) => {
	const url = `api/axle_import/carriers/${carrierId}/axle_driver/${axleDriverId}`;
	return createRequest()
		.delete(url, { headers: createHeaders() })
		.then((res) => res.data)
		.catch((error) => throwResErrors(error));
};

export const importAxleRecords = (carrierId, data) => {
	const url = `api/axle_import/carriers/${carrierId}`;
	return createRequest()
		.put(url, { data }, { headers: createHeaders() })
		.then((res) => res.data)
		.catch((error) => throwResErrors(error));
};

export const createUserLinkedAccount = (userId, data) => {
	const url = `api/profile/users/${userId}/accounts`;
	return createRequest()
		.post(url, { data }, { headers: createHeaders() })
		.then((res) => res.data)
		.catch((error) => throwResErrors(error));
};

export const getAxleTrucks = (carrierId, ids) => {
	const url = `api/axle_import/carriers/${carrierId}/trucks`;
	return createRequest()
		.get(url, { headers: createHeaders() })
		.then((res) => res.data)
		.catch((error) => throwResErrors(error));
};

export const getAxleDrivers = (carrierId, ids) => {
	const url = `api/axle_import/carriers/${carrierId}/drivers`;
	return createRequest()
		.get(url, { headers: createHeaders() })
		.then((res) => res.data)
		.catch((error) => throwResErrors(error));
};

export const importAxleDrivers = (carrierId, ids) => {
	const url = `api/axle_import/carriers/${carrierId}/drivers`;
	return createRequest()
		.put(url, { data: { ids } }, { headers: createHeaders() })
		.then((res) => res.data)
		.catch((error) => throwResErrors(error));
};

export const importAxleTrucks = (carrierId, ids) => {
	const url = `api/axle_import/carriers/${carrierId}/trucks`;
	return createRequest()
		.put(url, { data: { ids } }, { headers: createHeaders() })
		.then((res) => res.data)
		.catch((error) => throwResErrors(error));
};
